import { createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "sugnup__form__inputs" }
const _hoisted_2 = { class: "inputs" }
const _hoisted_3 = { class: "inputs__name" }
const _hoisted_4 = { class: "inputs" }
const _hoisted_5 = { class: "inputs__email" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" @ ")
const _hoisted_7 = { class: "email-sub" }
const _hoisted_8 = { class: "inputs" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "-required" }, "8자리이상, 숫자, !@#$%^&+= 중 1개 포함", -1)
const _hoisted_10 = { class: "inputs" }
const _hoisted_11 = { class: "inputs" }
const _hoisted_12 = { class: "inputs" }
const _hoisted_13 = { class: "inputs__sex" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("남자")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("여자")
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "p-dialog-title" }, [
  /*#__PURE__*/_createVNode("img", { src: "/images/new/signmail.png" }),
  /*#__PURE__*/_createVNode("p", null, "인증 메일이 발송되었습니다.")
], -1)
const _hoisted_17 = { class: "message" }
const _hoisted_18 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "-royalBlue" }, "계정 활성화", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 버튼을 선택하면 회원가입이 완료됩니다. ")
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "guidance" }, [
  /*#__PURE__*/_createVNode("span", null, "인증메일을 받지 못하셨나요?"),
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", null, "- 혹시 인증번호를 메일로 받지 못하였나요?"),
    /*#__PURE__*/_createVNode("li", null, "- 정확한 이메일 주소를 등록하셨는지 확인해주세요"),
    /*#__PURE__*/_createVNode("li", null, "- 스팸 메일함을 확인해주세요")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Field = _resolveComponent("Field")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_InputMask = _resolveComponent("InputMask")
  const _component_Alert = _resolveComponent("Alert")
  const _component_CustomConfirmDialog = _resolveComponent("CustomConfirmDialog")
  const _component_Form = _resolveComponent("Form")

  return (_openBlock(), _createBlock(_component_Form, {
    class: "signup__form",
    onSubmit: _ctx.signup
  }, {
    default: _withCtx(({ errors }) => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("label", {
            for: "name",
            class: { '-invalid': errors.familyName || errors.firstName }
          }, " 성함 ", 2),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Field, {
              modelValue: _ctx.inputData.familyName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputData.familyName = $event)),
              name: "familyName",
              rules: "required"
            }, {
              default: _withCtx(({ field }) => [
                _createVNode(_component_InputText, _mergeProps({
                  id: "familyName",
                  type: "text",
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => (field.value = $event)
                }, field, {
                  "aria-placeholder": "성",
                  placeholder: "성",
                  class: "half input-field"
                }), null, 16, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_Field, {
              modelValue: _ctx.inputData.firstName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputData.firstName = $event)),
              name: "firstName",
              rules: "required"
            }, {
              default: _withCtx(({ field }) => [
                _createVNode(_component_InputText, _mergeProps({
                  id: "firstName",
                  type: "text",
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => (field.value = $event)
                }, field, {
                  "aria-placeholder": "이름",
                  placeholder: "이름",
                  class: "half input-field"
                }), null, 16, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("label", {
            for: "email",
            class: { '-invalid': errors.emailName || errors.emailProvider }
          }, _toDisplayString(_ctx.t("email")), 3),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_Field, {
              modelValue: _ctx.email.emailName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.email.emailName = $event)),
              name: "emailName",
              rules: "required|emailName"
            }, {
              default: _withCtx(({ field }) => [
                _createVNode(_component_InputText, _mergeProps({
                  id: "email",
                  type: "text",
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => (field.value = $event)
                }, field, { class: "half input-field" }), null, 16, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_6,
            _createVNode(_component_Field, {
              modelValue: _ctx.email.emailProvider,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.email.emailProvider = $event)),
              name: "emailProvider",
              rules: "required|emailProvider"
            }, {
              default: _withCtx(({ field }) => [
                _createVNode(_component_InputText, _mergeProps({
                  id: "email",
                  type: "text",
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => (field.value = $event)
                }, field, {
                  disabled: !_ctx.isSelf,
                  class: "half input-field"
                }), null, 16, ["modelValue", "onUpdate:modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_Dropdown, {
              modelValue: _ctx.selectedEmailProvider,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedEmailProvider = $event)),
              options: _ctx.emailProviders,
              optionLabel: "name",
              class: "full input-field"
            }, null, 8, ["modelValue", "options"]),
            _createVNode(_component_Button, {
              type: "button",
              onClick: _ctx.checkEmail,
              class: "check-button input-field",
              disabled: !_ctx.state.isPossibleEmailButton
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("EmailCheck")), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_Field, {
            modelValue: _ctx.inputData.password,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.inputData.password = $event)),
            name: "password",
            rules: "required|password"
          }, {
            default: _withCtx(({ field }) => [
              _createVNode("label", {
                for: "password",
                class: { '-invalid': errors.password }
              }, [
                _createTextVNode(_toDisplayString(_ctx.t("password")) + " ", 1),
                _hoisted_9
              ], 2),
              _createVNode(_component_InputText, _mergeProps({
                id: "password",
                type: "password",
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => (field.value = $event)
              }, field, { class: "full input-field" }), null, 16, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_Field, {
            modelValue: _ctx.inputData.passwordConfirm,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.inputData.passwordConfirm = $event)),
            name: "passwordConfirm",
            rules: "required|confirmed:@password"
          }, {
            default: _withCtx(({ field }) => [
              _createVNode("label", {
                for: "passwordConfirm",
                class: { '-invalid': errors.passwordConfirm }
              }, _toDisplayString(_ctx.t("passwordConfirm")), 3),
              _createVNode(_component_InputText, _mergeProps({
                id: "passwordConfirm",
                type: "password",
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => (field.value = $event)
              }, field, { class: "full input-field" }), null, 16, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_Field, {
            modelValue: _ctx.inputData.birthDate,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.inputData.birthDate = $event)),
            name: "birthDate",
            rules: "required"
          }, {
            default: _withCtx(({ field }) => [
              _createVNode("label", {
                for: "birthDate",
                class: { 'p-invalid': errors.birthDate }
              }, _toDisplayString(_ctx.t("birthDate")), 3),
              _createVNode(_component_InputMask, _mergeProps({
                id: "birthDate",
                type: "birthDate",
                modelValue: field.value,
                "onUpdate:modelValue": ($event: any) => (field.value = $event)
              }, field, {
                class: "full input-field",
                mask: "9999/99/99",
                slotChar: "yyyy/mm/dd"
              }), null, 16, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1032, ["modelValue"])
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("label", {
            for: "sex",
            class: { '-invalid': errors.sex }
          }, _toDisplayString(_ctx.t("sex")), 3),
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_Button, {
              type: "button",
              class: ["half", _ctx.inputData.sex === _ctx.SEX.M ? 'active' : ''],
              onClick: _cache[9] || (_cache[9] = 
              () => {
                _ctx.inputData.sex = _ctx.SEX.M;
              }
            )
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_Button, {
              type: "button",
              class: ["half", _ctx.inputData.sex === _ctx.SEX.F ? 'active' : ''],
              onClick: _cache[10] || (_cache[10] = 
              () => {
                _ctx.inputData.sex = _ctx.SEX.F;
              }
            )
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["class"])
          ])
        ])
      ]),
      (!!_ctx.alert.content)
        ? (_openBlock(), _createBlock(_component_Alert, {
            key: 0,
            alert: _ctx.alert,
            "onUpdate:alert": _cache[11] || (_cache[11] = ($event: any) => (_ctx.alert = $event)),
            isConfirm: true,
            "onUpdate:clear": _cache[12] || (_cache[12] = 
        () => {
          _ctx.alert.content = '';
        }
      )
          }, null, 8, ["alert"]))
        : _createCommentVNode("", true),
      _createVNode(_component_CustomConfirmDialog, {
        group: "emailSend",
        isButton: false,
        class: "dialog"
      }, {
        title: _withCtx(() => [
          _hoisted_16
        ]),
        message: _withCtx(() => [
          _createVNode("div", _hoisted_17, [
            _createTextVNode(_toDisplayString(_ctx.inputData.email) + " 메일을 확인 바랍니다. ", 1),
            _hoisted_18,
            _hoisted_19,
            _hoisted_20
          ])
        ]),
        footer: _withCtx(() => [
          _hoisted_21
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}